<template>
    <div class="mb-4">
        <label
            :for="name"
            v-html="label"
            class="block text-sm font-medium text-gray-700"
        />
        <div class="relative mt-1 rounded-md shadow-sm">
            <input
                ref="textInput"
                :type="type"
                :inputmode="inputmode"
                :id="name"
                :name="name"
                :pattern="pattern"
                :value="modelValue"
                :placeholder="placeholder"
                class="block w-full border pr-10 p-2 focus:outline-none sm:text-sm rounded-md"
                :class="{
                    'border-red-300 text-red-900 placeholder-red-300 focus:border-red-500 focus:ring-red-500':
                        errors.length !== 0,
                    'border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500':
                        errors.length === 0,
                }"
                :max="max"
                :min="min"
                :maxlength="maxlength"
                :step="step"
                @focus="onFocus"
                @blur="onBlur"
                @input="updateInput"
                @keydown="onKeyDown"
            />
            <div
                v-if="errors.length !== 0 && !loading"
                class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3"
            >
                <!-- Heroicon name: solid/exclamation-circle -->
                <svg
                    class="h-5 w-5 text-red-500"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                >
                    <path
                        fill-rule="evenodd"
                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                        clip-rule="evenodd"
                    />
                </svg>
            </div>

            <div
                v-if="loading"
                class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3"
            >
                <!-- Heroicon name: solid/exclamation-circle -->
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-5 w-5 text-gray-500"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                    />
                </svg>
            </div>
        </div>
        <span
            class="absolute right-0 top-0 text-sm text-gray-600"
            v-if="!required"
            >Facultatif</span
        >
        <p
            v-for="(error, index) in errors"
            class="mt-2 text-sm text-red-600"
            :id="name - +'error'"
            :key="index"
            v-html="error"
        />
    </div>
</template>
<script>
export default {
  name: "text-input",
};
</script>
<script setup>
import { ref, watch } from "vue";
const props = defineProps({
  label: {
    type: String,
    default: "",
  },
  loading: {
    type: Boolean,
    default: false,
  },
  pattern: {
    type: String,
    default: "",
  },
  placeholder: {
    type: String,
    default: "",
  },
  type: {
    type: String,
    default: "text",
  },
  inputmode: {
    type: String
  },
  name: {
    type: String,
    default: null,
  },
  modelValue: {
    type: String,
    default: "",
  },
  required: {
    type: Boolean,
    default: false,
  },
  requiredMessage: {
    type: String,
    default: "Ce champ est obligatoire",
  },
  donnerLeFocus: {
    type: Boolean,
    required: false
  },
  maxlength: {
    type: [String, Number],
    required: false
  },
  step: {
    type: [String, Number],
    required: false
  },
  min: {
    type: Number,
    required: false
  },
  max: {
    type: Number,
    required: false,
  },
  errors: {
    default: function () {
      return [];
    },
  },
});
const emit = defineEmits(["update:modelValue", "focus", "onKeyDown", "onKeyUp", 'mousedown']);
const focus = ref(false);
const textInput = ref(null);
const updateInput = function (event) {
  emit("update:modelValue", event.target.value);
};
const onFocus = function (event) {
  emit("focus", event);
  focus.value = true;
};
const onBlur = function () {
  focus.value = false;
};

function onKeyDown(event) {
  emit('onKeyDown', event);
}

watch(() => props.donnerLeFocus, (nouvelleValeur, ancienneValeur) => {
  if (nouvelleValeur === true) {
    textInput.value.focus();
  } else {
    textInput.value.blur();
  }
})
</script>
